import React from 'react';
import { render } from 'react-dom';
import CardListWithFilterContainer from './container';
import { configureStore } from '@reduxjs/toolkit';
import filterReducer from './filterListSlice';
import { Provider } from 'react-redux';

export default {
  init: function (element: HTMLElement, id: number) {
    if (element) {
      const store = configureStore({
        reducer: filterReducer,
      });

      render(
        <Provider store={store}>
          <CardListWithFilterContainer blockId={id} />
        </Provider>,
        element
      );
    }
  },
};
